import {
  Button,
  ChakraSelect,
  FormControl,
  FormLabel,
  HStack,
  Stack,
  useBoolean,
  useDisclosure,
} from '@elkaso-app/web-design';
import { usePageParams } from 'hooks/use-page-params';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { BaseFilterButton } from '../../../../components/base-table/filters/base-filter-button';

type TInputs = {
  businessStatus?: {
    value: string;
    label: string;
  };
};

type TOption = {
  value: string;
  label: string;
};

const businessStatusOptions: TOption[] = [
  {
    value: 'OPERATIONAL',
    label: 'Operational',
  },
  {
    value: 'CLOSED_TEMPORARILY',
    label: 'Closed Temporarily',
  },
  {
    value: 'CLOSED_PERMANENTLY',
    label: 'Closed Permanently',
  },
];

const defaultValues: TInputs = {
  businessStatus: undefined,
};

export const CrmGoogleLocationFilterButton = () => {
  const [isActive, setIsActive] = useBoolean(false);
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { getPageParams, setPageParams } = usePageParams();
  const params = getPageParams();

  // Update active filter button
  useEffect(() => {
    if (params.businessStatus) setIsActive.on();
    else setIsActive.off();
  }, [params.businessStatus]);

  const { control, handleSubmit, formState, reset, setValue } = useForm<TInputs>({
    defaultValues: { ...defaultValues },
  });

  // Update values
  const updateValues = () => {
    setValue(
      'businessStatus',
      businessStatusOptions.find((o) => {
        if (params?.businessStatus) {
          return o.value === params?.businessStatus;
        }

        return undefined;
      })
    );
  };

  useEffect(() => {
    updateValues();
  }, [params.businessStatus]);

  const onSubmit = (data: TInputs) => {
    params.businessStatus = data.businessStatus?.value as string;

    setPageParams(params);
    onClose();
    reset(data);
  };

  const handleClose = () => {
    onClose();
    updateValues();
  };

  const handleDisableFilterButton = () => {
    const isDisabled = Object.keys(formState.dirtyFields).length ? false : true;
    return isDisabled;
  };

  return (
    <BaseFilterButton
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={handleClose}
      isActive={isActive}
      formComponent={
        <Stack as='form' spacing='lg' p='md' pt='lg' onSubmit={handleSubmit(onSubmit)}>
          <Controller
            control={control}
            name='businessStatus'
            render={({ field: { onChange, name, onBlur, value } }) => (
              <FormControl>
                <FormLabel>Business Status</FormLabel>
                <ChakraSelect
                  id='businessStatus'
                  options={businessStatusOptions}
                  onChange={onChange}
                  name={name}
                  onBlur={onBlur}
                  value={value}
                />
              </FormControl>
            )}
          />

          <HStack justify='flex-end'>
            <Button variant='outline' colorScheme='red' onClick={handleClose}>
              Cancel
            </Button>
            <Button variant='solid' colorScheme='red' type='submit' disabled={handleDisableFilterButton()}>
              Filter
            </Button>
          </HStack>
        </Stack>
      }
    />
  );
};
